module.exports = __webpack_public_path__ + "img/overview-custom.ec8d45e0.png";